export default __webpack_public_path__ + "static/media/sanskar.4d95d175.jpg";